import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import withStyles from "@material-ui/core/styles/withStyles";
import { get, map, round, toUpper } from "lodash";

import Accordion from "components/Accordion/Accordion.jsx";
import Assignment from "@material-ui/icons/Assignment";
import BouncingLoader from "components/EnergyCompany/BouncingLoader/BouncingLoader.jsx";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoGrid from "components/EnergyCompany/Grid/InfoGrid.jsx";
import InfoGridItem from "components/EnergyCompany/Grid/InfoGridItem.jsx";
import { fetchCargasEGeracao } from "services/companies";
import { localeString } from "services/utils";

const styles = {
  contentWrapper: {
    width: "100%",
    "& h4": {
      fontWeight: "normal !important",
    },
  },
  wrapper: {
    "& h4": {
      fontWeight: "bold",
    },
  },
};

class CargaEGeracao extends Component {
  state = {
    agents: [],
    loading: true,
  };

  componentDidMount() {
    fetchCargasEGeracao(this.props.companyId).then(({ data }) => {
      this.setState({ agents: data, loading: false });
    });
  }

  render() {
    const { agents, loading } = this.state;
    const { classes } = this.props;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            content={
              <div className={classes.wrapper}>
                {loading ? (
                  <BouncingLoader />
                ) : (
                  <Accordion
                    collapses={map(agents, agent => ({
                      content: (
                        <div className={classes.contentWrapper}>
                          {agent.cargas && (
                            <div>
                              <h4>Cargas</h4>
                              <Accordion
                                collapses={map(agent.cargas, carga => ({
                                  content: (
                                    <InfoGrid>
                                      <InfoGridItem label="Código" value={carga.codigoCarga} />
                                      <InfoGridItem label="Nome" value={carga.nomeCarga} />

                                      <InfoGridItem
                                        label="Submercado"
                                        modifiers={["forceNewRowModifier"]}
                                        value={toUpper(carga.submercado)}
                                      />
                                      <InfoGridItem label="Estado" value={toUpper(carga.estado)} />

                                      <InfoGridItem
                                        label="Consumo 12M"
                                        modifiers={["forceNewRowModifier"]}
                                        value={localeString(carga.consumo.energiaMediaMWMed) + " MW Médio"}
                                      />
                                      <InfoGridItem label="Cidade" value={toUpper(carga.cidade)} />

                                      <InfoGridItem
                                        label="Distr. Conectada"
                                        modifiers={["forceNewRowModifier"]}
                                        value={toUpper(carga.nomeDistribuidora)}
                                      />
                                      <InfoGridItem label="Capacidade Carga" value={carga.capacidadeCargaKW + " KW"} />

                                      <InfoGridItem
                                        label="Data Migração"
                                        modifiers={["forceNewRowModifier"]}
                                        value={moment(carga.dataMigracao).format("DD/MM/YYYY")}
                                      />
                                      <InfoGridItem label="Proinfa 12M" value={localeString(get(carga, "energiaProinfa.energiaMediaMWMed", '')) + " MWMéd"} />
                                    </InfoGrid>
                                  ),
                                  title: `${carga.nomeCarga} - ${carga.estado} - ${localeString(carga.consumo.energiaMediaMWMed)} MW Médio`,
                                }))}
                              />
                            </div>
                          )}
                          {agent.geracoesUsinas && (
                            <div>
                              <h4>Geração</h4>
                              <Accordion
                                collapses={map(agent.geracoesUsinas, geracao => ({
                                  content: (
                                    <InfoGrid>
                                      <InfoGridItem label="Código" value={geracao.codigoParcelaUsina} />
                                      <InfoGridItem label="Nome" value={geracao.nomeParcelaUsina} />

                                      <InfoGridItem
                                        label="Garantia Física"
                                        modifiers={["forceNewRowModifier"]}
                                        value={geracao.garantiaFisicaMWMed ? localeString(geracao.garantiaFisicaMWMed) + " MW Médio" : "--"}
                                      />
                                      <InfoGridItem label="Desconto" value={geracao.desconto * 100 + "%"} />

                                      <InfoGridItem
                                        label="Geração 12 meses"
                                        modifiers={["forceNewRowModifier"]}
                                        value={localeString(geracao.geracao.energiaMediaMWMed) + " MW Médio"}
                                      />
                                      <InfoGridItem label="Potência" value={geracao.capacidadeMW + " MW"} />

                                      <InfoGridItem
                                        label="Fator de Capacidade"
                                        modifiers={["forceNewRowModifier"]}
                                        value={round(geracao.fatorCapacidade * 100) + "%"}
                                      />
                                      <InfoGridItem label="Fator Op. Comercial" value={round(geracao.fatorOperacaoComercial * 100) + "%"} />

                                      <InfoGridItem
                                        label="Início Op. Comercial"
                                        modifiers={["forceNewRowModifier"]}
                                        value={moment(geracao.dataInicioOperacaoComercial).format("DD/MM/YYYY")}
                                      />
                                      <InfoGridItem label="Particpa MRE" value={geracao.participaMRE ? "Sim" : "Não"} />

                                      <InfoGridItem
                                        label="Fonte Primaria"
                                        modifiers={["forceNewRowModifier"]}
                                        value={geracao.fonteEnergiaPrimaria}
                                      />
                                      <InfoGridItem label="CEG" value={geracao.ceg} />

                                      <InfoGridItem
                                        label="Despacho"
                                        modifiers={["forceNewRowModifier"]}
                                        value={geracao.despachoParcelaUsina}
                                      />
                                    </InfoGrid>
                                  ),
                                  title: `${geracao.nomeParcelaUsina} - ${geracao.estadoParcelaUsina} - ${localeString(geracao.geracao.energiaMediaMWMed)} MW Médio`,
                                }))}
                              />
                            </div>
                           )}
                        </div>
                      ),
                      title: agent.nomePerfilAgente,
                    }))}
                  />
                )}
              </div>
            }
            icon={<Assignment />}
            title="Pontos de Carga e Geração"
          />
        </GridItem>
      </GridContainer>
    );
  }
};

CargaEGeracao.propTypes = {
  classes: PropTypes.object.isRequired,
  companyId: PropTypes.string.isRequired,
};

export { CargaEGeracao as CargaEGeracaoComponent };
export default withStyles(styles)(CargaEGeracao);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/CargaEGeracao.jsx